import styles from './Page.module.css';
import './styles.css';
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import classNames from 'classnames';
import { Tabs, Tab, Paper, IconButton, Button, Collapse, Zoom, Fade } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ArrowBack, Save } from '@mui/icons-material';
import { Spin, Empty, Alert } from 'antd';
import { LoadingOutlined, SaveOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { AuthContext } from '../../AuthContext'; // Import AuthContext from the file where it is defined
import Menu from '../../components/Menu/component';
import useMenu from '../../components/Menu/useMenu'; // Шлях до вашого файлу useMenu.js


const theme = createTheme({
  palette: {
    primary: {
      main: '#277cff',
    },
    secondary: {
      main: '#068306',
    },
  },
});

const FiltersPage = () => {
  const navigate = useNavigate();
  const user = useContext(AuthContext); // Отримання значення _id з контексту
  const [regionTab, setRegionTab] = useState(0);
  const [moreTab, setMoreTab] = useState(0);
  const [catLocTab, setCatLocTab] = useState(0);
  const [locationTab, setLocationTab] = useState(0);
  const [categoriesList, setCategoriesList] = useState([]);
  const [locationsList, setLocationsList] = useState([]);
  const [filteredCategoriesList, setFilteredCategoriesList] = useState([]);
  const [filteredLocationsList, setFilteredLocationsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [saveMessage, setSaveMessage] = useState('');
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [isLoadingCategories, setIsLoadingCategories] = useState(true);
  const [isLoadingLocations, setIsLoadingLocations] = useState(true);
  const [isLoadingUser, setIsLoadingUser] = useState(true);
  const { isOpen, toggleMenu, handleMenuItemClick } = useMenu();



// console.log('user');
// console.log(user);

useEffect(() => {
  async function getUser() {
    console.log('user');
    console.log(user);

    const dataForRequest = {
      _id: user._id, // Включення _id користувача
    };
    const response = await fetch('/api/user/getUser', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dataForRequest),
    });
    let data = await response.json();
    
    if (!data.categories || data.categories.length == 0) {
      data.categories = [{}]
    }

    if (!data.locations || data.categories.locations == 0) {
      data.locations = [{}]
    }
    // Оновлення значень selectedCategories з отриманих даних
    // const userCategories = data.categories.map(category => category.name);
    setSelectedCategories(data.categories);
    setSelectedLocations(data.locations);
    console.log('user');
    console.log(data);
    setIsLoadingUser(false); // Позначаємо, що завантаження користувача завершено
  }

  if (user && user._id) {
      console.log('user2');
  console.log(user);

    getUser();
  } else{
    const savedCategories = localStorage.getItem('userCategories');
    const savedLocations = localStorage.getItem('userLocations');
    if (savedCategories) {
      setSelectedCategories(JSON.parse(savedCategories));
    }
    if (savedLocations) {
      setSelectedLocations(JSON.parse(savedLocations));
    }
    setIsLoadingUser(false);
  }
    async function getCategories() {
      setIsLoadingCategories(true);
      const dataForRequest = {
        source: regionTab === 0 ? 'UkrNet' : 'UP',
      };
      const response = await fetch('/api/reviews/getcategoriesList', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataForRequest),
      });
      let data = await response.json();
      // Функція порівняння для сортування за полем name
      function compareByName(a, b) {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      }

  if (data && data.length > 0) {
      // Сортування масиву за полем name
      data.sort(compareByName);
  } else {
    data = [{}]
  }
      setFilteredCategoriesList(data);
      setIsLoadingCategories(false);
    }

    async function getLocations() {
      setIsLoadingLocations(true);
      const dataForRequest = {
        source: regionTab === 0 ? 'UkrNet' : 'UP',
      };
      const response = await fetch('/api/reviews/getLocationsList', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataForRequest),
      });
      let data = await response.json();
      // Функція порівняння для сортування за полем name
      function compareByName(a, b) {
        const nameA = a.name.toUpperCase();
        const nameB = b.name.toUpperCase();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      }

      // Сортування масиву за полем name
      data.sort(compareByName);
      setFilteredLocationsList(data);
      setIsLoadingLocations(false);
    }
    getCategories();
    getLocations();
  }, [regionTab, user]);

  const handleRegionTabChange = (event, newValue) => {
    setRegionTab(newValue);
  };

  const handleMoreTabChange = (event, newValue) => {
    setMoreTab(newValue);
  };

  const handleCatLocTabChange = (event, newValue) => {
    setCatLocTab(newValue);
  };

  const handleLocationTabChange = (event, newValue) => {
    setLocationTab(newValue);
  };

  const goBack = () => {
    navigate(-1);
  };

  const handleCategoryClick = (category) => {
    // Перевірка, чи обраний елемент вже міститься в масиві
    const isSelected = selectedCategories ? 
    selectedCategories.some(
      (currentCategory) => category._id === currentCategory._id
    ) : null;
    if (isSelected) {
      // Якщо обраний елемент вже міститься, видалити його з масиву
      const updatedCategories = selectedCategories.filter((item) => item._id !== category._id);
      setSelectedCategories(updatedCategories);
    } else {
      // Якщо обраний елемент ще не міститься, додати його до масиву
      setSelectedCategories([...selectedCategories, category]);
    }
  };

  const handleLocationClick = (location) => {
    // Перевірка, чи обраний елемент вже міститься в масиві
    const isSelected = selectedLocations.some(
      (currentLocation) => location._id === currentLocation._id
    );
    if (isSelected) {
      // Якщо обраний елемент вже міститься, видалити його з масиву
      const updatedLocations = selectedLocations.filter((item) => item._id !== location._id);
      setSelectedLocations(updatedLocations);
    } else {
      // Якщо обраний елемент ще не міститься, додати його до масиву
      setSelectedLocations([...selectedLocations, location]);
    }
  };

  const handleSave = async () => {
    try {
      setIsSaving(true);
  
      localStorage.setItem('userCategories', JSON.stringify(selectedCategories))
      localStorage.setItem('userLocations', JSON.stringify(selectedLocations))
      if (user && user._id) {
        // Формування оновлених даних користувача
        const updatedUserData = {
          _id: user._id, // Включення _id користувача
          categories: selectedCategories,
          locations: selectedLocations,
        };

        // Відправка оновлених даних на сервер
        await fetch('/api/user/userUpdate', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updatedUserData),
        });
      }

  
      // Оновлення даних користувача в стані додатку (якщо потрібно)
      // setUserData(updatedUserData);
  
      setIsSaving(false);
      setSaveSuccess(true);

      // Показати підтвердження на певний час
      setTimeout(() => {
        setSaveSuccess(false);
      }, 2000);
      setSaveMessage('Дані користувача успішно оновлено.');
    } catch (error) {
      setIsSaving(false);
      setSaveMessage('Помилка під час оновлення даних користувача.');
      console.error('Помилка під час оновлення даних користувача:', error);
    }
  };  
  

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24,
      }}
      spin
    />
  );

  return (
    <ThemeProvider theme={theme}>
      {isLoadingUser ? (
        <div className="spinnerContainer">
          <Spin size="large" indicator={antIcon} />
        </div>
      ) : (
        <div className={styles.root}>
          <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <IconButton onClick={goBack}>
              <ArrowBack />
            </IconButton>
            <div style={{ marginLeft: '35px' }}>
              <Tabs
                value={regionTab}
                onChange={handleRegionTabChange}
                indicatorColor={regionTab === 0 ? 'primary' : 'secondary'}
                textColor={regionTab === 0 ? 'primary' : 'secondary'}
              >
                <Tab label="Регіон" />
                <Tab label="За межами" />
              </Tabs>
            </div>
            <IconButton onClick={handleSave} style={{ width: '50px' }}>
              {isSaving ? (
                <Zoom in={!saveSuccess}>
                  <Spin indicator={antIcon} />
                </Zoom>
              ) : saveSuccess ? (
                <Fade in={saveSuccess}>
                  <CheckCircleOutlined style={{ color: '#00cc00', fontSize: '28px' }} />
                </Fade>
              ) : (
                <Zoom in={!saveSuccess}>
                  <Collapse in={!saveSuccess}>
                    <SaveOutlined style={{ color: '#005deb', fontSize: '28px' }} />
                  </Collapse>
                </Zoom>
              )}
            </IconButton>
          </div>
          {isLoadingCategories || isLoadingLocations ? ( // Змінено перевірку isLoading на isLoadingCategories та isLoadingLocations
            <div className="spinnerContainer">
              <Spin size="large" indicator={antIcon} />
            </div>
          ) : (
            <Paper className="content">
              <Tabs
                value={catLocTab}
                onChange={handleCatLocTabChange}
                indicatorColor={regionTab === 0 ? 'primary' : 'secondary'}
                textColor={regionTab === 0 ? 'primary' : 'secondary'}
                variant="fullWidth"
              >
                <Tab label="Категорії" />
                <Tab label="Локації" />
              </Tabs>
              {(!user || Object.keys(user).length === 0) && (
                <div  className={styles.alertContainer}>
                  <Alert
                    message={
                      <span>
                        Поки Ви не авторизуєтесь налаштування зберігатимуться лише на цьому пристрої. <br/>Вам потрібно <Link to="/login"><span className={styles.LoginLink}>увійти</span></Link>, щоб налаштування збереглись у "хмарі", а також були доступними на інших Ваших пристроях.
                      </span>
                    }
                    type="warning"
                    showIcon
                  />
                </div>
              )}
              {regionTab === 0 ? (
                catLocTab === 0 ? (
                  filteredCategoriesList.length > 0 ? (
                    <ul className="record-list">
                      {filteredCategoriesList
                          .filter(category => category.source === 'UkrNet')
                          .map((category) => (
                          <div
                            key={category.id}
                            className={`record-item ${selectedCategories && selectedCategories.some(
                              (currentCategory) => category._id === currentCategory._id
                            ) ? 'active' : ''}`}
                            onClick={() => handleCategoryClick(category)}
                          >
                            {category.name}
                          </div>
                        ))}
                    </ul>
                  ) : (
                    <Empty description="Немає даних" />
                  )
                ) : (
                  filteredLocationsList.length > 0 ? (
                    <ul className="record-list">
                    {filteredLocationsList
                        .filter(location => location.source === 'UkrNet')
                        .map((location) => (
                        <div
                          key={location.id}
                          className={`record-item ${selectedLocations.some(
                            (currentLocation) => location._id === currentLocation._id
                          ) ? 'active' : ''}`}
                          onClick={() => handleLocationClick(location)}
                        >
                          {location.name}
                        </div>
                      ))}
                    </ul>
                  ) : (
                    <Empty description="Немає даних" />
                  )
                )
              ) : (
                    catLocTab === 0 ? (
                      filteredCategoriesList.length > 0 ? (
                        <ul className="record-list">
                          {filteredCategoriesList
                              .filter(category => category.source === 'UP')
                              .map((category) => (
                              <div
                                key={category.id}
                                className={`record-item ${selectedCategories.some(
                                  (currentCategory) => category._id === currentCategory._id
                                ) ? 'active' : ''}`}
                                onClick={() => handleCategoryClick(category)}
                              >
                                {category.name}
                              </div>
                            ))}
                        </ul>
                      ) : (
                        <Empty description="Немає даних" />
                      )
                    ) : (
                      filteredLocationsList.length > 0 ? (
                        <ul className="record-list">
                        {filteredLocationsList
                            .filter(location => location.source === 'UP')
                            .map((location) => (
                            <div
                              key={location.id}
                              className={`record-item ${selectedLocations.some(
                                (currentLocation) => location._id === currentLocation._id
                              ) ? 'active' : ''}`}
                              onClick={() => handleLocationClick(location)}
                            >
                              {location.name}
                            </div>
                          ))}
                        </ul>
                      ) : (
                        <Empty description="Немає даних" />
                      )
                    )
                  )}
            </Paper>
          )}
          </div>
      )}
    </ThemeProvider>
  );
};

export default FiltersPage;
